import { Component, OnInit, HostListener } from '@angular/core';
import { PathLocationStrategy } from '@angular/common';
import { PrimeiroAcesso } from '../model';
import {ActivatedRoute} from '@angular/router';
import {AuthenticationService} from '../service';
import {AdvGrowlService} from 'primeng-advanced-growl';
import {constants} from '../app-constants';
import {UsuarioLogadoModel} from '../model';
import { CookieService } from 'ngx-cookie-service';

import { PropertiesLocales } from '../util/properties-locale';

@Component({
  selector: 'app-primeiro-acesso',
  templateUrl: './primeiro-acesso.component.html',
  styleUrls: ['./primeiro-acesso.component.css']
})
export class PrimeiroAcessoComponent implements OnInit {

  cpf: boolean;
  cnpj: boolean;
  isDisabled: boolean;
  mask: string;
  hideMask: boolean;
  public properties: PropertiesLocales = new PropertiesLocales();
  public message: any;
  primeiroAcesso: any;
  msgRegister: string;
  email: string;
  documento: string;
  errorValidator: Array<any>;
  public basePath: string;

  constructor(private _primeiroAcesso: PrimeiroAcesso,
              private route: ActivatedRoute,
              private advGrowlService: AdvGrowlService,
              private cookieService: CookieService,
              private authenticationService: AuthenticationService,
              private pathLocationStrategy: PathLocationStrategy) {
    this.primeiroAcesso = _primeiroAcesso;
  }

  ngOnInit() {
    this.cpf = false;
    this.cnpj = false;
    this.isDisabled = true;
    this.hideMask = this.isLocalePtBr();

    this.basePath = this.pathLocationStrategy.getBaseHref();
    let local = localStorage.getItem(constants.locale);
    const uri = this.basePath.substring(7).replace('/', '').toString();

    if (!local.match(uri)) { // prevalece o locale definido na URL
      local = uri.replace('/', '');
    }

    switch (local) {
      case 'es':
       this.message = this.properties.items_steps_es;
      break;
      case 'en':
      this.message = this.properties.items_steps_en;
      break;
      default:
      this.message = this.properties.items_steps_pt;
      break;
    }

    this.route.queryParams.subscribe(params => {
      if (params.idEmpresa !== undefined) {
        this.primeiroAcesso.idEmpresa = params['idEmpresa'];
        this.cookieService.set( 'idEmpresa', this.primeiroAcesso.idEmpresa );
        localStorage.setItem('idEmpresa', this.primeiroAcesso.idEmpresa);
      } else {
        const usuarioLogadoModel: UsuarioLogadoModel = JSON.parse( localStorage.getItem(constants.usuarioLogadoKey) );
        if (usuarioLogadoModel != null) {
          this.primeiroAcesso.idEmpresa = usuarioLogadoModel.idEmpresa;
        } else {
          this.primeiroAcesso.idEmpresa = this.cookieService.get('idEmpresa');
          if (!this.primeiroAcesso.idEmpresa) {
            this.primeiroAcesso.idEmpresa = localStorage.getItem('idEmpresa');
          }
        }
      }
    });
  }

  doRegister() {
    if (!this.primeiroAcesso.idEmpresa) {
      this.primeiroAcesso.idEmpresa = this.cookieService.get('idEmpresa');
      if (!this.primeiroAcesso.idEmpresa) {
        this.primeiroAcesso.idEmpresa = localStorage.getItem('idEmpresa');
      }
      if (!this.primeiroAcesso.idEmpresa) {
        /*LOGA ERRO*/
        this.msgRegister = this.message[12].msg_service_error_empresaid;
        this.advGrowlService.createTimedErrorMessage(this.message[12].msg_service_error_empresaid, '', 2000);
        return;
      }
    }
    if ((this.email == null || this.email === '') || (this.documento == null || this.documento === '')) {
      this.advGrowlService.createTimedErrorMessage(this.message[13].msg_service_error_firstaccess_fields, '', 2000);
      return;
    }

    // TODO: Vai ser usado no futuro.
    //this.documento.replace(/[^\w\s]/gi, '')

    this.primeiroAcesso.email = this.email;
    this.primeiroAcesso.documento = this.documento;
    this.primeiroAcesso.api = 'PortalCliente';
    this.primeiroAcesso.url = window.location.href;
    this.authenticationService.firstAccess(this.primeiroAcesso);
  }
  @HostListener('click', ['$event'])
   onChange($event) {
    if ($event === 'cpf') {
      this.isDisabled = false;
      this.mask = '000.000.000-00';
    }
    if ($event === 'cnpj') {
      this.isDisabled = false;
      this.mask = '00.000.000/0000-00';
    }
  }

  isLocalePtBr(): boolean {
    let locale = this.cookieService.get('locale');
    if (!locale) {
      locale = localStorage.getItem('locale');
    }
    if (locale === 'pt') {
        this.isDisabled = true;
        return false;
    } else {
        this.isDisabled = false;
        return true;
    }
  }

}
